import { render, staticRenderFns } from "./SankeyChart.vue?vue&type=template&id=24b57afc&"
import script from "./SankeyChart.vue?vue&type=script&lang=js&"
export * from "./SankeyChart.vue?vue&type=script&lang=js&"
import style0 from "./SankeyChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports